export default "__VITE_ASSET__dqxOOn2p__"